import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-section-dropdown',
  templateUrl: './SectionDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => SectionDropdownComponent)}]
})
export class SectionDropdownComponent extends BaseDropdownComponent {

    
    constructor(private domainDataService: serv.DomainDataService) 
    {
        super();
    }


    ngOnInit(): void {
    }

    public load(){

        this.domainDataService.getSections().subscribe(x=> this.onGetSectionsDone(x));
    }
    
    onGetSectionsDone(items: ent.Section[]){
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.FriendlyName, value:y.ID}));
        this.value = this.selectedID;
    }

}